module.exports = __webpack_public_path__ + "media/images/sports_icons/004-bowling-pins-8884b555f60d5b88d4417a7f51fbc648.png";